import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import { IconButton, InputAdornment, TextField } from '@material-ui/core';

const SearcherPro = ({ textSearch, handleChangeTextSearch }) => {
    return (
        <TextField
                id="input-with-icon-textfield"
                value={textSearch}
                onChange={event => handleChangeTextSearch(event.target.value)}
                className={'searcher-pro'}
                style={{ maxWidth: '50%', width: '600px', position: 'fixed', zIndex: 999, top: '50px' }}
                placeholder="Buscar"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="start">
                            <IconButton disabled={textSearch === ""} onClick={() => handleChangeTextSearch("")}>
                                <ClearIcon/>
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
    )
}

export default SearcherPro